import React, { useState,useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentsTrainer, getPaymentsClient } from "../../state/paymentSlice";
import {updateProgramAssign} from './Packages/packagesSlice'
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js'
import { envAwarePost } from "../../util/util";
import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Toast from "react-bootstrap/Toast"
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import {
	setMultiFormsModal
} from '../../state/customFormsSlice'


const PurchaseModal = ({ show, toggle, paymentType, totalSessions, totalPurchase, meta,onSuccess }) => {
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const stripe = useStripe()
	const elements = useElements()
	const statusPost = useApiStatusEnvAwarePost()

	const confirmPayment = () => stripe.confirmPayment({
		elements,
		confirmParams: {
			return_url: 'https://www.fitsw.com',
		},
		redirect:'if_required'
	})

	const finalizePaymentIntent = (payload) => (
		statusPost("api/purchases/trainer_page/", payload,paymentType,'purchase')
	)

	const stripeAccount = useSelector(
		state => state.users.current_user.trainer_stripe_account
	)

	const clientUserId = useSelector(
		state => state.users.current_user.user_id
	)

	const clientName = useSelector(
		state => state.users.current_user.user_name
	)
	
	const trainerId = useSelector(
		state => state.users.current_user.bio_data.user_trainer_id
	)

	const [assignSuccess, setAssignSuccess] = useState(false)
	


	const [status, setStatus] = useState()

	//if packages were purchased that had associated programs 
	//forward to the program assignemnt options
	const forwardToProgramPackageAssignment = programs => {
		//get all packages with these programs
		dispatch(updateProgramAssign({
			show:true,
			programs
		}))
	}

	const forwardToForms = (forms,programs) => {
		//assign the forms to the client then forward to 
		//the modal for them to fill out the newly assigned forms
		envAwarePost('api/customForms/',{
			action:'addFormsToClient',
			form_ids:forms.map(form=>form.form_id),
		}).then(()=>{
			dispatch(setMultiFormsModal({
				show:true,
				programs,
				forms
			}))
		})
	}

	const handlePurchase = async (e, totalPurchase) => {

		// Block native form submission.
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		if (totalPurchase == "") {
			alert('You must specify an amount to pay.')
			return
		}
		else if (totalPurchase > 5001) {
			alert('We currently do not accept payments over $5000. Please email us at support@fitsw.com if you need to make a payment of this size.');
			return
		}
		else if (totalPurchase < 10) {
			alert('We currently do not accept payments under $10. Please email us at support@fitsw.com if you need to make a payment of this size.');
			return
		} else {
			// convert payment amount to pennies
			totalPurchase = Math.round(Number(totalPurchase) * 100);
		}
		setStatus('loading')
		
		confirmPayment()
		.then(res => {
			if (res.error) throw new Error(res.error.message)
			if (res.paymentIntent.status !== 'succeeded') throw new Error("Something went wrong. Please, try again")
			const payment_intent_id = res.paymentIntent.id
			return finalizePaymentIntent({
				action: 'finalizePaymentIntent',
				stripe_user_id: stripeAccount,
				payment_intent_id
			})
		}).then(res => {
			if (res.success === '1') {
				setStatus('idle')
				toggle();
				onSuccess()
				//if packages were purchased with associated programs
				//then forward to the assignment options. if there are forms
				//these must be filled out first
				if(paymentType==='packages'&&meta.programs.length>0&&meta.forms.length===0){
					forwardToProgramPackageAssignment(meta.programs)
				}
				//if packages were purchased with associated forms
				//then forward to the forms
				if(meta.forms.length>0){
					forwardToForms(meta.forms,meta.programs)
				}
			} else {
				throw new Error(res.message)
			}
		}).catch(err => {
			setStatus('idle')
			window.alert(err)
		})
	}
	
	return (
		<Modal show={show} onHide={toggle} centered>
			<Modal.Header style={{ background: '#1174ef' }} closeButton>
			</Modal.Header>
			<Modal.Body>
				<PaymentElement
					options={{
						hidePostalCode: true,
						style: {
							base: {
								fontSize: '16px',
								color: '#424770',
								'::placeholder': {
									color: '#aab7c4',
								},
							},
							invalid: {
								color: '#9e2146',
							},
						},
					}}
				/>
				<Button
					disabled={status === 'loading'}
					variant="outline-primary"
					onClick={(e) => handlePurchase(e, totalPurchase)}
					className="mt-2"
					block
				>
					{
						status === 'loading' ?
							<Spinner animation="border" size="sm" />
							:
							'Make Payment'
					}
				</Button>
				<Toast className="my-3" onClose={() => {
					setAssignSuccess(false)
					toggle();
				}
				} show={assignSuccess} delay={2000} autohide style={{ textAlign: "center", margin: "auto", color: 'white', backgroundColor: '#4FD69C' }}>
					<Toast.Body><strong>Payment Successful</strong></Toast.Body>
				</Toast>
			</Modal.Body>

		</Modal>
	)
}

export default PurchaseModal